export default {
  form: {
    display_name: {
      label: 'Nazwa restauracji',
      placeholder: 'Wprowadź nazwę restauracji',
      help: 'Używane na umowie i fakturach',
    },
    store_address: {
      label: 'Adres lokalu',
      placeholder: 'Wyszukaj swój adres',
      help: 'To adres widoczny dla klientów',
    },
    address: {
      label: 'Adres',
      placeholder: 'Ulica i numer',
    },
    zip_code: {
      label: 'Kod pocztowy',
      placeholder: 'Kod pocztowy',
    },
    city: {
      label: 'Miasto',
      placeholder: 'Miasto',
    },
    state: {
      label: 'Województwo',
      placeholder: 'Wybierz województwo',
    },
    country: {
      label: 'Kraj',
      help: 'Aby przenieść restaurację do innego kraju, skontaktuj się z pomocą techniczną',
    },
  },
  staff_notice:
    'Pracownicy lokalu nie mogą potwierdzić nazwy i adresu restauracji. Poproś swojego opiekuna wdrożenia o sprawdzenie tych danych.',
  toasts: {
    saved: 'Dane lokalu zapisane',
    error: 'Nie udało się zapisać danych lokalu',
  },
  buttons: {
    next: 'Dalej',
  },
};
